import React from 'react';
import { ActivityFormV2 } from './ActivityFormV2';

export const CreateActivityScreenV2 = () => {
  return <ActivityFormV2 />;
};
